import React from 'react'

import ToastError from '@components/atoms/Error'
import ToastNotification from '@components/atoms/Toast'
import {
	Header,
	ModalFreeLimit,
	ModalBlackFriday,
	SideMenu,
	ModalQuestionErrorReport,
	ModalEditPhone,
} from '@components/molecules'
import { ModalFreeSevenQuestions } from '@components/molecules/ModalFreeSevenQuestions'
import { useIsMobile } from '@hooks'
import { useAppSelector } from '@store/hooks'
import { css, styled } from '@styles/theme'

type PropsBody = {
	children: JSX.Element
}

const wrapper = css({
	display: 'flex',
	flexDirection: 'row',
})

const container = css({
	display: 'flex',
	justifyContent: 'center',
})

const body = css({
	width: '100%',
})

const SideSpace = styled('div', {
	display: 'flex',
	justifyContent: 'center',
	width: '100%',
	height: '100% ',
	paddingLeft: '277px',
	background: '$neutral30',

	variants: {
		isOpened: {
			false: {
				paddingLeft: '75px',
			},
		},
	},
})

export function Body({ children }: PropsBody) {
	const { header } = useAppSelector((state) => state)

	const mobile = useIsMobile()

	return (
		<main className={container()}>
			<div className={body()}>
				<Header />
				<div className={wrapper()}>
					<SideMenu />
					<SideSpace
						isOpened={JSON.parse(header.value)}
						css={mobile ? { padding: '0px' } : {}}
					>
						{children}
					</SideSpace>
					<ToastNotification />
					<ToastError />
					<ModalFreeLimit />
					<ModalFreeSevenQuestions />
					<ModalQuestionErrorReport />
					<ModalBlackFriday />
					<ModalEditPhone />
				</div>
			</div>
		</main>
	)
}
